import { Component, EventEmitter, Input, NgZone, OnInit, Output, SimpleChange } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { StorageService } from 'src/app/Services/storage.service';
import { MapService } from 'src/app/Services/map.service';
declare const mapUtilityMapBox;
declare const Swal;
declare var google: any;


@Component({
  selector: 'g10-rostering-favourite-location',
  templateUrl: './rostering-favourite-location.component.html',
  styleUrls: ['./rostering-favourite-location.component.css']
})
export class RosteringFavouriteLocationComponent implements OnInit {

  @Input() popup  = true;
  @Input() modalTitle  = 'Location';
  @Input() edit:boolean = false;
  @Input() locationData;
  @Input() googleSearch:boolean = false;
  @Output() closeEvent = new EventEmitter();
  @Output() result = new EventEmitter();
 
  public favouriteLocationMap:any;
  public pickupFromMap:boolean = false;
  public favLocEnableForm:boolean = false;
  public favLocTitle:any;


  markerId = 'favouriteLocationSelection';
  markerRadiusId = 'favourite-location-radius';
  public favouriteLocation = {};
  public branchLocation = {};
  public parkingLocation = {}; 

  public selectedLocation = {};
  public selectedLocKey:any;
  public selectedTypeofLoc:any;

  public showSuggestionBadge:boolean = false;
  public showBranch:boolean = false;
  public showParking:boolean = false;

  public addLocationForm:any = {
    title:'',location:{ lat:'',lng:'',name:''},
  };
  public formSubmitted:boolean = false;
  
  public mapSearchChangeObserver: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  public showMap:boolean = false;

  public enableAddForm:boolean = false;
  public enableFavLocEdit:boolean = false;
  public editFavLocID:any;
  public locationObj = {};

  public objKeys = Object.keys;

      //for map
  public selectedMap:string='openStreetMap';
  // public selectedMap:string='google';
  private googleMapObj: any;
  public gglPickupPointMarker:any=[];
  public pickupRadiusCircle:any;

  constructor( 
    public api:ApiService,
    public swal:SweetAlert,
    public ngZone:NgZone,
    public storage:StorageService,
    private mapService: MapService,
    ) {}

  ngOnInit(): void {
    let user= this.storage.get('userInfo');
    if(user && user.map){
      this.selectedMap = user.map;
    }

    this.initMap();
    this.getBranchData();
    this.getParkingData();
    this.getFavouriteLocations();
  }

  ngOnChanges(changes:SimpleChange){
    if (changes['locationData'] && this.edit){
      this.locationData = { ...changes['locationData'].currentValue};
      setTimeout(()=>{
        if(this.selectedMap=='google'){
          if(Object.keys(this.locationData).length > 0) this.patchEditLocation(this.locationData);
        }else{
          if(Object.keys(this.locationData).length > 0 && this.favouriteLocationMap) this.patchEditLocation(this.locationData);
        }
      },3000);
    }
  }
  
  initMap(){
        if(this.selectedMap=='google'){
          this.showMap=true;
          setTimeout(()=>{
            const mapOptions = {
              scrollwheel: true,
              zoom: 5,
              maxZoom: 17,
              center: new google.maps.LatLng(20.5937, 78.9629),
              fullscreenControl: false,
              zoomControl: true,
              zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
              },
              mapTypeControl: true,
              mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_CENTER,
              },
              streetViewControl: false,
            };
              this.googleMapObj = new google.maps.Map(document.getElementById('favouriteLocationMap'), mapOptions);
              google.maps.event.addListener(this.googleMapObj,'click', (e) => {
                  this.LocationChanged(+e.latLng.lat(),+e.latLng.lng());
                  this.removeCircleAndMarker();
                  this.gglPickupPointMarkerLoc(+e.latLng.lat(),+e.latLng.lng(),'');
                  let loc={
                      lat: +e.latLng.lat(),
                      lng: +e.latLng.lng()
                  }
                  this.drawCircleGgl(loc,'');
              });
          },1000)
      } else{
        try {
            const mapBoxKey = 'pk.eyJ1Ijoib3dlbmxhbWIiLCJhIjoiY2lleWljcnF4MDBiOXQ0bHR0anRvamtucSJ9.t3YnHHqvQZ8Y0MTCNy0NNw';
            const parent = this;
            if (mapBoxKey) {
              const MyMap1 = new mapUtilityMapBox();
              MyMap1.setup('favouriteLocationMap', {
                key: mapBoxKey
              },
                function (map) {             
                  parent.favouriteLocationMap = map;  
                  parent.showMap = true;
                  parent.favouriteLocationMap.onMapClick(($event) => parent.mapClickEventListen($event));    
                });
            }
          } catch (error) {
            console.log(error);
          }
      }
    }
    drawCircleGgl(loc,radius){
      if(radius == '' || radius == 0){
        radius = 1;
      }
      if(this.pickupRadiusCircle){
        this.pickupRadiusCircle.setMap(null);
      }
      this.pickupRadiusCircle = new google.maps.Circle({
          strokeColor: "rgb(98,100,167)",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "rgb(154,155,194)",
          fillOpacity: 0.35,
          map: this.googleMapObj,
          center: loc,
          radius: radius * 1000,
        });
  }
  gglPickupPointMarkerLoc(lat,lng,name){
    this.removeCircleAndMarker();
    let loc={
        lat : +lat,
        lng : +lng,
      }
      let image = {
        scaledSize: new google.maps.Size(24, 36),
        url: "assets/images/map/googleMap/pickuppoint-purple.png"
      };
    this.gglPickupPointMarker.push(new google.maps.Marker({
      position:loc,
      map: this.googleMapObj,
      icon:image,
      // draggable: true
    }));
    // for(let i=0;i<this.gglPickupPointMarker.length;i++){
    //   this.gglPickupPointMarker[i].addListener('dragend',(e)=>{
    //     console.log(e);
    //   })
    // }
    this.drawCircleGgl(loc,'');
    this.googleMapObj.setZoom(13);
    this.googleMapObj.panTo(loc);
  }
  getBranchData(){
    this.api.transportManagerBranchList({}).then((res: any) => {
      if (res.status == 'success') {
        if(Array.isArray(res.data) && res.data.length>0){
          for(let b=0;b<res.data.length;b++){
            let data = res.data[b];
            this.branchLocation[data['branchID']] = { ...data};
          }
        this.showBranch = true;
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  
  getParkingData(){
    this.api.transportManagerParkingList({}).then((res: any) => {
      if (res.status == 'success') {
        if(Array.isArray(res.data) && res.data.length>0){
          for(let p=0;p<res.data.length;p++){
            let data = res.data[p];
            this.parkingLocation[data['parkingID']] = { ...data};
          }
        }
        this.showParking = true;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  
  getFavouriteLocations(){
    this.showSuggestionBadge = false;
    this.favouriteLocation = {};
    this.api.transportManagerFavouriteLocationList({}).then((res: any) => {
      if (res.status == 'success') {
        if(Array.isArray(res.data) && res.data.length>0){
          for(let f=0;f<res.data.length;f++){
            let data = res.data[f];
            this.favouriteLocation[data['favlocID']] = { 
              location:{ lat:data.lat,lng:data.lng,name:data.name},
              ...data,
            };
          }
        }
      }
      setTimeout(()=>{ this.showSuggestionBadge = true;},200)
    }).catch((err) => {
      console.log(err);
    });
   /*  if(Array.isArray(data)){
      data.filter((element)=>{ 
        let title = element[key];
        this.favouriteLocation[title] = { ...element}; 
      });
    } */
  }

  patchEditLocation(locationObj){
    let obj = { ...locationObj};
    if(obj.type=='branch') this.patchLocation(obj.id,'branchLocation');
    else if(obj.type=='parking') this.patchLocation(obj.id,'parkingLocation');
    else if(obj.type=='favourite')  this.patchLocation(obj.id,'favouriteLocation');
    else if(obj.type=='random'){
      obj['lngLat'] = { lat:obj.lat, lng:obj.lng};
      if(this.selectedMap=='google'){
        this.gglPickupPointMarkerLoc(+obj.lat,+obj.lng,'');
      }else{
        this.mapClickEventListen(obj);
      }
    }
  }

  setBranchLocations(data){ console.log('branch locations',data);}
  setParkingLocations(data){ console.log('parking locations',data);}

  mapClickEventListen($event) {
    if(!this.favLocEnableForm) this.pickupFromMap = true;
    this.selectedLocKey = undefined;
    // if (this.pickupFromMap === false) return
    console.log($event)
    this.locationMarker($event['lngLat']['lat'], +$event['lngLat']['lng']);

    this.LocationChanged($event['lngLat']['lat'], +$event['lngLat']['lng'])

    this.latlngDrawRadius($event['lngLat']['lat'], $event['lngLat']['lng']);

    if(this.favouriteLocationMap && this.markerId){
      this.favouriteLocationMap.onDrag([this.markerId], (e) => {
          // console.log(e.target._lngLat['lat']);
          this.LocationChanged(e.target._lngLat['lat'], e.target._lngLat['lng'])
          this.latlngDrawRadius(+e.target._lngLat['lat'], e.target._lngLat['lng']);
          // markerId
      });
    }
  }

  locationMarker(lat, lng) {
    lat = +lat.toFixed(5); lng = +lng.toFixed(5);
    this.favouriteLocationMap.marker(
        {
            id: this.markerId,
            content: '<div class="mumb_marker_pin" style="background: #686ab9;"></div>',
            lat: lat,
            lng: lng,
            draggable: true   // <<<<< Important
        }
    );
    this.favouriteLocationMap.focus({
        lat: lat,
        lng: lng,
        zoom: 14
    });
  }
  patchLocation(key,typeOfLocation){
    this.selectedLocKey = key;
    this.selectedTypeofLoc = typeOfLocation;
    this.favLocEnableForm = false;
    this.pickupFromMap = false;
    
    if(this.selectedMap=='google'){
      this.gglPickupPointMarkerLoc(+this[typeOfLocation][key]['location']['lat'], +this[typeOfLocation][key]['location']['lng'],'');
      let loc={
        lat: +this[typeOfLocation][key]['location']['lat'],
        lng: +this[typeOfLocation][key]['location']['lng']
      }
      this.drawCircleGgl(loc,'');
    }else{
      this.locationMarker(this[typeOfLocation][key]['location']['lat'], +this[typeOfLocation][key]['location']['lng']);
      this.latlngDrawRadius(this[typeOfLocation][key]['location']['lat'], this[typeOfLocation][key]['location']['lng']);
    }
    this.LocationChanged(this[typeOfLocation][key]['location']['lat'], +this[typeOfLocation][key]['location']['lng'])

  }

  LocationChanged(lat, lng,locationName?) {
    this.addLocationForm['location']['lat'] = +lat.toFixed(5);
    this.addLocationForm['location']['lng'] = +lng.toFixed(5);
    if(locationName && locationName!=''){
      this.addLocationForm['location']['name'] = locationName;                
    }
    else{
      let obj={
          "params":{
            "latlng":`${+lat.toFixed(5)},${+lng.toFixed(5)}`
          }
        }
        this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
          if (res.status == 'success') {
            let response=JSON.parse(res.data);
            this.addLocationForm['location']['name'] = response['results'][0]['formatted_address'];
          }
        }).catch((err) => {
          console.log(err);
        });
      // if(this.selectedMap=='google'){
      //   console.log('Google')
      //   // let obj={
      //   //   "params":{
      //   //     "latlng":`${+lat.toFixed(5)},${+lng.toFixed(5)}`
      //   //   }
      //   // }
      //   // this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
      //   //   if (res.status == 'success') {
      //   //     let response=JSON.parse(res.data);
      //   //     this.addLocationForm['location']['name'] = response['results'][0]['formatted_address'];
      //   //   }
      //   // }).catch((err) => {
      //   //   console.log(err);
      //   // });
      // }else{
      //   this.favouriteLocationMap.geocoder(`${lng},${lat}`, (res) => {
      //       try {
      //         const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } })
      //         this.addLocationForm['location']['name'] = locations[0]['name'];                
      //     } catch (er) { console.log(er) };
      //   });
      // }
    }
    setTimeout(()=>{ 
      this.selectedLocation = { ...this.addLocationForm['location']};   
    },500);
  }

  latlngDrawRadius(lat, lng) {
      this.favouriteLocationMap.drawCircle({
          name: this.markerRadiusId, // unique like id
          lat: +lat.toFixed(5), lng: +lng.toFixed(5),
          km: '0.3',
          color: "rgba(255,0,0,0.2)"
      });
  }
  mapSearchFind(location) {

    // clearTimeout(this.mapSearchDebounceTimeOut);
    // this.mapSearchDebounceTimeOut = setTimeout(() => {
    //     this.favouriteLocationMap.geocoder(
    //         `${location}`, (res) => {
    //             try {
    //                 // console.log(res.features);
    //                 const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
    //                 // this.pickupPoints[this.editIndex]['location'] = locations[0]['name'];
    //                 this.favouriteLocationMap.focus({
    //                     lat: locations[0]['center'][1],
    //                     lng: locations[0]['center'][0],
    //                     zoom: 15
    //                 });
    //                 this.mapSearchDataLists = [];
    //                 this.mapSearchDataLists = locations;
    //             } catch (er) { console.log(er) };
    //         });

    // }, 600);

    location = location.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.mapSearchChangeObserver) {
    new Observable(observer => {
        this.mapSearchChangeObserver = observer;
    }).pipe(debounceTime(1000)) // wait 1000ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
            // your code here
            if(term==''){
                this.mapSearchDataLists = [];
            }
            else{
                if(this.googleSearch){
                  const options = {
                      fields: ["formatted_address", "geometry", "name"],
                      strictBounds: false,
                      types: ["establishment"],
                  };
  
                  const searchInput: any = document.getElementById('mapSearchBox');// as HTMLInputElement;
  
                  const autocomplete = new google.maps.places.Autocomplete(searchInput, options);
                  // let results = []
                  autocomplete.addListener('place_changed', () => {
                      this.ngZone.run(() => {
                          const getResults = autocomplete.getPlace();
                          /*
                          Example Data 
                          getRestults = {
                              "formatted_address": "7, th street, Subramaniam Colony, Ram Nagar South, Madipakkam, Chennai, Tamil Nadu 600096, India",
                              "geometry": {
                                  "location": {
                                      "lat": 12.9678217,
                                      "lng": 80.2185006
                                  },
                                  "viewport": {
                                      "south": 12.9665866697085,
                                      "west": 80.21685966970848,
                                      "north": 12.9692846302915,
                                      "east": 80.21955763029149
                                  }
                              },
                              "name": "Velachery Railway Station",
                              "html_attributions": []
                          } */
                          try{
                              let name = getResults.formatted_address ? getResults.formatted_address : ''; 
                              let lat = getResults.geometry && getResults.geometry.location && getResults.geometry.location.lat() ? getResults.geometry.location.lat() : '';
                              let lng = getResults.geometry && getResults.geometry.location && getResults.geometry.location.lng() ? getResults.geometry.location.lng() : '';
                              if(lat != '' && lng !=''){
                                  if(!this.favLocEnableForm) this.pickupFromMap = true;
                                  this.selectedLocKey = undefined;
                                  if(this.selectedMap=='google'){
                                    this.gglPickupPointMarkerLoc(+lat,+lng,name);
                                    let loc={
                                      lat: +lat,
                                      lng: +lng
                                    }
                                    this.drawCircleGgl(loc,'');
                                    this.googleMapObj.setZoom(15);
                                  }else{
                                    this.locationMarker(+lat,+lng);
                                    this.latlngDrawRadius(+lat,+lng);
                                  }
                                  this.LocationChanged(+lat,+lng,name);
                              }
                          }catch(err){
                              console.log('location bind error',err);
                          }
  
                      });
                  });          

                }else{
                  this.favouriteLocationMap.geocoder(
                            `${term}`, (res) => {
                                try {
                                    // console.log(res.features);
                                    const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
                                    // this.pickupPoints[this.editIndex]['location'] = locations[0]['name'];
                                    this.favouriteLocationMap.focus({
                                        lat: locations[0]['center'][1],
                                        lng: locations[0]['center'][0],
                                        zoom: 15
                                    });
                                    this.mapSearchDataLists = [];
                                    this.mapSearchDataLists = locations;
                                } catch (er) { console.log(er) };
                            });
                }                
            }
        });
    }

    this.mapSearchChangeObserver.next(location);

}

  removeCircleAndMarker() {
      
      if(this.selectedMap=='google'){
        if(this.gglPickupPointMarker.length>0){
          for(let i=0;i<this.gglPickupPointMarker.length;i++){
          this.gglPickupPointMarker[i].setMap(null);
          }
        }
        if(this.pickupRadiusCircle){
          this.pickupRadiusCircle.setMap(null);
        }
    }else{
      this.favouriteLocationMap.removeMarker(this.markerId);
      this.favouriteLocationMap.removeCircle(this.markerRadiusId);
    }
  }
  closePopup(){
    this.closeEvent.emit(true);
  }
  onSubmit(){

    let obj = { 
      lat:this.addLocationForm.location.lat,
      lng:this.addLocationForm.location.lng,
      name:this.addLocationForm.location.name,
      title:'',
    };
    if((this.selectedLocKey && this.selectedLocKey != '') && (this.selectedTypeofLoc && this.selectedTypeofLoc !='')){
      obj['id'] = this.selectedLocKey;
      obj['title'] = this[this.selectedTypeofLoc][this.selectedLocKey]['title'];
      if(this.selectedTypeofLoc == 'branchLocation') {
        obj['type'] = 'branch';
        obj['title'] = this[this.selectedTypeofLoc][this.selectedLocKey]['branchName'];
      }
      if(this.selectedTypeofLoc == 'parkingLocation') obj['type'] = 'parking';
      if(this.selectedTypeofLoc == 'favouriteLocation') obj['type'] = 'favourite';
    }
    else{
      if(this.formSubmitted) obj['title'] = this.favLocTitle;
      obj['type'] = 'random';
    }
    console.log(obj);
    if(obj.lat!='' && obj.lng!='' && obj.name!=''){
      this.result.emit(obj);
      this.closePopup();
    }
  }
   
  addForm(){
    this.favLocEnableForm = !this.favLocEnableForm;
    this.favLocTitle = '';
    this.pickupFromMap = false;
  }
  onFormSubmit(){
    this.formSubmitted = true;
    if(this.formValidation()){
      let obj = {
        title: this.favLocTitle,
        ...this.addLocationForm['location'],
      };
      let apiMethod = 'transportManagerFavouriteLocationCreate';
      if(this.enableFavLocEdit){
        apiMethod = 'transportManagerFavouriteLocationUpdate';
        obj['favlocID']= this.editFavLocID;
      }
      this.api[apiMethod](obj).then((res: any) => {
        if (res.status == 'success') {
            this.swal.swalFunction(res.status, res.status, res.message, 2000);
            setTimeout(() => {
                this.getFavouriteLocations();
                this.formSubmitted = false;
                this.initMap();
            }, 3000)
        } else {
            this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      });
    }
  }
  formValidation(){
    let result = true;
    if(this.favLocTitle=='' || this.favLocTitle == undefined) result = false;
    let formKeys = Object.keys(this.addLocationForm['location']);
    formKeys.filter((key)=>{ if(this.addLocationForm['location'][key] == '' || this.addLocationForm['location'][key] == undefined) result = false;})
    return result;
  }
  cancelForm(){
    this.favLocEnableForm = false;
    this.favLocTitle = '';
    this.pickupFromMap = true;
  }

  /* Favourite Location Actions */
  editFavLocation(location,key,typeofLocation){
    this.enableFavLocEdit = true;
    this.patchLocation(key,typeofLocation);
    this.favLocTitle = location.title;
    this.editFavLocID = key;
    this.pickupFromMap = false;
    this.favLocEnableForm = !this.favLocEnableForm;
  }
  editCancel(){
    this.enableFavLocEdit = false;
    this.favLocEnableForm = false;
    this.favLocTitle = '';
    this.pickupFromMap = false;
  }
  // Favourite Location Delete

  deleteFavLocation(location) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
      this.deleteFavouriteLocation(location);
     /* Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        ); */
      }
    });
  }

  deleteFavouriteLocation(location){
    let obj = { favlocID:location.favlocID, };
  this.api.transportManagerFavouriteLocationDelete(obj).then((res: any) => {
      if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          setTimeout(() => {
              this.getFavouriteLocations();
          }, 3000)
      } else {
          this.swal.swalFunction('error', res.status, res.message, 2000);
      }
  })
  }

}
